import React from 'react';
import { Link } from 'react-scroll';

const TableOfContents = ({ headings }) => {
  if (!headings || headings.length === 0) {
    return null;
  }

  return (
    <nav style={{
      padding: '30px 20px',
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <h3 style={{
        marginTop: '0',
        marginBottom: '25px',
        fontSize: '0.8rem',
        textTransform: 'uppercase',
        letterSpacing: '1px',
        color: '#888',
        fontWeight: 'bold'
      }}>
        On this page
      </h3>
      <ul style={{ listStyle: 'none', padding: '0', margin: '0' }}>
        {headings.map((heading, index) => (
          <li key={index} style={{
            marginBottom: '4px',
            marginLeft: `${(heading.level - 1) * 15}px`
          }}>
            <Link
              activeStyle={{
                color: '#1a73e8',
                fontWeight: '600',
                borderLeft: '2px solid #1a73e8',
                backgroundColor: '#f1f7ff'
              }}
              to={heading.id}
              spy={true}
              smooth={true}
              offset={-40}
              duration={500}
              style={{
                textDecoration: 'none',
                color: '#4f566b',
                fontSize: heading.level === 1 ? '15px' : '14px',
                display: 'block',
                cursor: 'pointer',
                padding: '8px 12px',
                borderRadius: '0 4px 4px 0',
                transition: 'all 0.2s ease',
                borderLeft: '2px solid transparent'
              }}
            >
              {heading.text}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default TableOfContents;
